import { render, staticRenderFns } from "./UploadIdCard.vue?vue&type=template&id=01d26b01"
import script from "./UploadIdCard.vue?vue&type=script&lang=js"
export * from "./UploadIdCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports